import UppyImageUploader from "discourse/components/uppy-image-uploader";
import FormFieldBase from "./base";
import FormFieldWireFrame from "./wire-frame";

export default class FormFieldImageUploader extends FormFieldBase {
  <template>
    <FormFieldWireFrame
      @fieldName={{this.fieldName}}
      @title={{this.title}}
      @description={{this.description}}
      @required={{@required}}
      @validation={{@validation}}
    >
      <UppyImageUploader
        class="circles-form-{{@name}}"
        ...attributes
        name={{this.fieldName}}
        @id={{this.fieldName}}
        @imageUrl={{@imageUrl}}
        @type={{@name}}
        @onUploadDone={{@onUploadDone}}
        @onUploadDeleted={{@onUploadDeleted}}
      />
      {{yield}}
    </FormFieldWireFrame>
  </template>
}
